import { render, staticRenderFns } from "./ClaimItem.vue?vue&type=template&id=0b5e8657"
import script from "./ClaimItem.vue?vue&type=script&lang=js"
export * from "./ClaimItem.vue?vue&type=script&lang=js"
import style0 from "./ClaimItem.vue?vue&type=style&index=0&id=0b5e8657&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports